import React from 'react';

import Dialog from '../../../../../../reusables/Dialog';
import DialogExtraCaption from '../../../../../../reusables/Dialog/extras/caption';

import confQuit from '../../../../../../../assets/illustrations/confirmation-quit.svg';

interface IProps {
  handlerBack: () => void;
  handlerClose: () => void;
  show: boolean;
}

const QuitPageModal = ({ handlerBack, handlerClose, show }: IProps) => (
  <Dialog
    handlerClose={() => handlerClose()}
    maxWidth="360px"
    show={show}
    zIndex={1000}
    textButtonA="Aceptar"
    handlerButtonA={() => handlerBack()}
    textButtonB="Cancelar"
    handlerButtonB={() => handlerClose()}
    img={confQuit}
  >
    <DialogExtraCaption
      subtitle="Recuerda que los cambios realizados no se guardarán."
      title="¿Deseas salir de esta página?"
    />
  </Dialog>
);

export default QuitPageModal;
